export const userSegmentJsonBuilder = (state, byOutcomeData) => ({
  id: state.id,
  tenantId: state.tenantId,
  default: state.default || false,
  name: state.name,
  testSettingByOutcome: byOutcomeData,
});
